import { i as r, a as s } from "./vendor-DWc995QB.mjs";
function m(i) {
  return r(i) || s(i);
}
export {
  m as i
};
//# sourceMappingURL=isNilOrEmpty-CFG8AFrT.mjs.map
